import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_POPOVER } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import {
  LineItemFulfilmentCustomerContactViewProps,
  LineItemFulfilmentCustomerContactView as LineItemFulfilmentCustomerContactViewUnified,
} from './LineItemFulfilmentCustomerContactView'
import { LineItemFulfilmentCustomerContactViewLegacy } from './LineItemFulfilmentCustomerContactViewLegacy'

export const LineItemFulfilmentCustomerContactView: React.FC<LineItemFulfilmentCustomerContactViewProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_POPOVER
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentCustomerContactViewUnified {...props} />
  ) : (
    <LineItemFulfilmentCustomerContactViewLegacy {...props} />
  )
}

export type { LineItemFulfilmentCustomerContactViewProps }
